<template>
  <div id="home" v-if="shop">
    <van-nav-bar
      :title="$t('ShopStatus.title')"
      left-arrow
      fixed
      @click-left="$router.go(-1)"
    >
    </van-nav-bar>
    <van-dialog v-model="isShopShow" :style="{ height: '70%' }">
      <van-cell-group>
        <van-cell>
          <template slot="title">
            <div style="color:#222; text-align:center;font-size: 18px; ">
              {{ $t("ShopStatus.publishsShop") }}
            </div>
          </template>
        </van-cell>
        <van-cell
          :title="$t('ShopStatus.servicePoint')"
          :value="sessionStorage.coins + $t('ShopStatus.count')"
        />
      </van-cell-group>
      <div class="cardGroup">
        <van-grid :border="true" :column-num="2" gutter="30px" square>
          <template v-for="(item, index) in periods">
            <van-grid-item
              :class="[actCardIndex == index ? 'actItem' : '']"
              @click="changeActIndex(index)"
            >
              <div>{{ item.title }}</div>
              <div>{{ item.number }}{{ $t("ShopStatus.count") }}</div>
              <div style="color:red">{{ item.discount }}</div>
            </van-grid-item>
          </template>
        </van-grid>
      </div>
      <van-tabbar>
        <van-button
          style="height: 35px;margin: 10px 3%;line-height: 35px;width: 94%;background: #E5E5E5;color:#222;"
          round
          @click="isShopShow = false"
          >{{ $t("ShopStatus.cancel") }}</van-button
        >
        <van-button
          style="height: 35px;margin: 10px 3%;line-height: 35px;width: 94%;background: #2f75f7;color:#fff;"
          round
          @click="activeShop()"
          >{{ $t("ShopStatus.certain") }}</van-button
        >
      </van-tabbar>
    </van-dialog>
    <van-popup v-model="isTipShow" position="bottom" :style="{ height: '75%' }">
      <van-cell value-class="tc" :value="$t('ShopStatus.note')">
        <van-icon
          slot="icon"
          name="./static/img/dele_Seat.png"
          size="25px"
          @click="isTipShow = false"
        />
      </van-cell>
      <ul>
        <li>
          <p>{{ $t("ShopStatus.p1") }}</p>
        </li>
        <li>
          <p>{{ $t("ShopStatus.p2") }}</p>
        </li>
        <li>
          <p>{{ $t("ShopStatus.p3") }}</p>
        </li>
        <li>
          <p>{{ $t("ShopStatus.p4") }}</p>
        </li>
      </ul>
    </van-popup>
    <van-cell-group>
      <van-cell>
        <span>{{ $t("ShopStatus.shopType") }}</span>
        <span
          :class="[shop.active == 0 ? 'shopType' : 'actType']"
          class="shopStatus"
        >
          <!-- {{shop.active==0?'未上线':'已上线'}} -->
          <span v-if="shop.active == 0">{{ $t("ShopStatus.inActive") }}</span>
          <span v-else>{{ $t("ShopStatus.active") }}</span>
        </span>
      </van-cell>
      <van-cell>
        <span>{{ $t("ShopStatus.canUse") }}</span>
        <span class="useDay">{{ shop.days }}{{ $t("ShopStatus.day") }}</span>
      </van-cell>
      <van-cell>
        <span>{{ $t("ShopStatus.note") }}</span>
        <span class="questionIcon"
          ><van-icon
            name="question-o"
            color="#fd3f3f"
            @click="isTipShow = true"
            size="25px"
        /></span>
      </van-cell>
    </van-cell-group>
    <van-button
      class="issueBtn"
      round
      type="default"
      style="font-weight:bold;font-size:16px;"
      @click="isShopShow = true"
      >{{ $t("ShopStatus.publishsShop") }}</van-button
    >
    <!-- <div class="bottom">
			<div :class="[shop.active==0?'shopType':'actType']">
				{{shop.active==0?'未上线':'已上线'}}
			</div>
			<div class="shopLeftTime">
			 	可使用:{{shop.days}}天
			</div>
			<van-icon name="question-o" color="#FFB20D" @click="isTipShow=true"  size="25px"/>
		</div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      shop: {},
      periods: [],
      isShopShow: false,
      isTipShow: false,
      time: 30,
      actId: "",
      maxTime: 0,
      actCardIndex: 0,
      actShopId: 0
    };
  },
  created() {
    this.actShopId = sessionStorage.getItem("actShopId");
  },
  mounted: function() {
    this.getShop();
    this.getPeriod();
  },
  methods: {
    // 获取激活周期列表
    getPeriod() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/period/index"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.periods = res.data.data;
            this.actId = res.data.data[0].id;
            this.time = res.data.data[0].number;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {});
    },
    // 获取店铺信息
    getShop() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + this.actShopId + "/show"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.shop = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopStatus.message")
          });
        });
    },
    // 上线店铺
    activeShop() {
      if (sessionStorage.coins >= this.time) {
        this.$dialog
          .confirm({
            title: this.$t("ShopStatus.shopOnLine"),
            message:
              this.$t("ShopStatus.text") +
              this.time +
              this.$t("ShopStatus.severceCount"),
            confirmButtonColor: "#2f75f7",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "PATCH",
              headers: {
                Authorization: "Bearer " + sessionStorage.token
              },
              url: this.$build + "/api/store/" + this.actShopId + "/active",
              data: {
                id: this.actId
              }
            })
              .then(res => {
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.isShopShow = false;
                  this.getShop();
                  var coins = sessionStorage.coins - this.time;
                  this.time = this.periods[this.actCardIndex].number;
                  sessionStorage.setItem("coins", coins);
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("ShopStatus.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("ShopStatus.InsufficientServicePoints")
        });
      }
    },
    // 修改选择周期
    changeActIndex(index) {
      this.actCardIndex = index;
      this.time = this.periods[index].number;
      this.actId = this.periods[index].id;
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-dialog__confirm {
  display: none;
}
/deep/ .van-image {
  font-size: 24px;
  vertical-align: top;
}
.home {
  width: 100%;
  height: 100%;
}
.issueBtn {
  width: 90%;
  height: 40px;
  line-height: 40px;
  margin-left: 5%;
  margin-top: 30px;
  background: #2f75f7;
  color: #fff;
  font-weight: bold;
  border: none;
}
.cardGroup {
  width: 96%;
  margin-left: 2%;
  margin-top: 30px;
}
/deep/ .van-grid-item__content {
  border: 2px solid #ccc;
  border-radius: 10px;
}
/deep/ .actItem .van-grid-item__content {
  border: 2px solid #2f75f7;
  border-radius: 10px;
}
.shopType {
  color: red;
  font-weight: bold;
}
.actType {
  width: 60px;
  color: #2f75f7;
  font-weight: bold;
}
/*分割线*/
.divideLine {
  height: 20px;
  background: #f3f5f7;
}
.shopStatus {
  float: right;
  text-align: right;
}
.useDay,
.questionIcon {
  float: right;
}
ul {
  list-style: decimal;
  /*padding-inline-start: 40px;*/
  padding: 0 10px 0 28px;
}
.tc {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/Shop/ShopStatus.vue